import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '../../../components/Button/CustomButton';
import styles from '../../../assets/jss/pages/listEventManagementStyle';
import EventDialog from '../../../containers/admin/EventManagement/EventDialog';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import Pagination from '../../../components/Pagination/Pagination';
import SnackBar from '../../../components/Snackbar/Snackbar';
import CustomTable from '../../../components/Table/Table';
import Loader from '../../../components/Loader/Loader';
import GridItem from '../../../components/Grid/GridItem';
import SettingRoleAdminDialog from '../../../containers/admin/EventManagement/SettingRoleAdminDialog';

const useStyles = makeStyles(styles);

const ActionRow = ({ onEdit, onDelete, ...rest }) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
        <Button onClick={onEdit} color="success" {...rest} style={{ fontSize: '14px' }}>編集</Button>
        &nbsp;
        <Button onClick={onDelete} color="danger" {...rest} style={{ fontSize: '14px' }}>削除</Button>
    </Box>
);

const ListEvents = ({
    fetchListEvents,
    listEvents,
    createSuccess,
    editSuccess,
    fetchClearGetDetailEvent,
    dataEvents,
    fetchDeleteEvent,
    deleteSucces,
    isLoading,
    clearDetailEvent,
    deleteError,
    clearListEvent,
}) => {
    const classes = useStyles();
    const history = useHistory();
    const intl = useIntl();

    const [isOpenDialogEvent, setIsOpenDialogEvent] = useState(false);
    const [isOpenDialogSettingRole, setIsOpenDialogSettingRole] = useState(false);
    const [isOpenDialogDelete, setIsOpenDialogDelete] = useState(false);
    const [isOpenSnackBar, setIsOpenSnackBar] = useState({ isOpen: false, color: '' });
    const [eventId, setEventId] = useState(0);
    const [eventShortName, setEventShortName] = useState(null);
    const [listEventState, setListEventState] = useState([]);
    const [messageAction, setMessageAction] = useState('');
    const [dataAccount, setDataAccount] = useState({});

    useEffect(() => {
        fetchListEvents();
        return () => {
            clearListEvent();
        };
    }, []);

    useEffect(() => {
        if (createSuccess) {
            fetchListEvents();
            setIsOpenSnackBar({ isOpen: true, color: 'success' });
            setMessageAction(intl.formatMessage({ id: 'apiSuccess.createEvent' }));
        }
    }, [createSuccess]);

    useEffect(() => {
        if (editSuccess) {
            fetchListEvents();
            setIsOpenSnackBar({ isOpen: true, color: 'success' });
            setMessageAction(intl.formatMessage({ id: 'apiSuccess.editEvent' }));
        }
    }, [editSuccess]);

    useEffect(() => {
        if (deleteSucces) {
            setIsOpenDialogDelete(false);
            setEventId(0);
            setEventShortName(null);
            fetchListEvents();
            setMessageAction(intl.formatMessage({ id: 'apiSuccess.default' }));
            clearDetailEvent();
        }
    }, [deleteSucces]);

    useEffect(() => {
        if (!_.isEmpty(deleteError)) {
            setIsOpenDialogDelete(false);
            setIsOpenSnackBar({ isOpen: true, color: 'error' });
            setMessageAction(deleteError.message.message);
            clearDetailEvent();
        }
    }, [deleteError]);

    useEffect(() => {
        if (!_.isEmpty(listEvents)) {
            const tableData = listEvents.map((event) => [
                event.id,
                event.name,
                event.short_name,
                event.description,
                `${format(new Date(event.sdate), 'yyyy/MM/dd')} ~ ${format(new Date(event.edate), 'yyyy/MM/dd')}`,
                <ActionRow onEdit={(e) => handleOpenDialogEvent(e, event.id, event.short_name)} onDelete={(e) => handleOpenDialogDelete(e, event.id, event.short_name)} size="sm" />,
            ]);
            setListEventState(tableData);
        }
    }, [listEvents]);

    const handleOpenDialogEvent = (e, id, shortName) => {
        if (id) {
            e.stopPropagation();
            setEventId(id);
            setEventShortName(shortName);
        }
        fetchClearGetDetailEvent();
        setIsOpenDialogSettingRole(true);
    };

    const handleCloseDialogEvent = () => {
        fetchClearGetDetailEvent();
        setEventId(0);
        setEventShortName(null);
        setIsOpenDialogEvent(false);
    };

    const handleCloseDialogSettingAccount = () => {
        fetchClearGetDetailEvent();
        setEventId(0);
        setEventShortName(null);
        setIsOpenDialogSettingRole(false);
    };

    const handleShowEventDetail = (index) => {
        if (listEventState[index]) {
            history.push(`/admin/${listEventState[index][2]}/company-event-management?payment=true`);
        }
    };

    const handleSearchWithPage = (page) => {
        fetchListEvents({
            page,
        });
    };

    const handleOpenDialogDelete = (e, id, shortName) => {
        e.stopPropagation();
        setEventId(id);
        setEventShortName(shortName);
        setIsOpenDialogDelete(true);
    };

    const handleCloseDialogDelete = () => {
        setEventId(0);
        setEventShortName(null);
        setIsOpenDialogDelete(false);
    };

    const handleDeleteEvent = () => {
        fetchDeleteEvent(eventId);
    };

    const handleSubmitAccount = (value, e, id, shortName) => {
        setDataAccount(value);
        setIsOpenDialogSettingRole(false);
        if (id) {
            e.stopPropagation();
            setEventId(id);
            setEventShortName(shortName);
        }
        setIsOpenDialogEvent(true);
        fetchClearGetDetailEvent();
    };

    return (
        <div className={classes.main}>
            <Button color="info" gradient size="md" className={classes.button} onClick={() => handleOpenDialogEvent()} style={{ fontSize: '20px', fontWeight: 'bold' }}>
                催し作成する
            </Button>
            <div className={classes.table_main}>
                {!_.isEmpty(listEvents) ? (
                    <CustomTable
                        onClick={(index) => handleShowEventDetail(index)}
                        tableHead={['id', '催し名', 'パス名', '概要', '開催期間', 'アクション']}
                        tableHeadWidth={['3%', '20%', '15%', '30%', '20%', '12%']}
                        tableData={listEventState}
                        tableFooter={(
                            <Box display="flex" justifyContent="center">
                                <Pagination
                                    page={dataEvents.page}
                                    total={dataEvents.total_page}
                                    onChange={(page) => handleSearchWithPage(page)}
                                />
                            </Box>
                        )}
                    />
                ) : (
                    <GridItem
                        xs={12}
                        style={{
                            textAlign: 'center', fontWeight: 'bold', fontSize: '20px', zIndex: 1,
                        }}
                    >
                        <FormattedMessage id="noData" />
                    </GridItem>
                )}
            </div>

            <SettingRoleAdminDialog
                isOpen={isOpenDialogSettingRole}
                handleClose={() => handleCloseDialogSettingAccount()}
                eventId={eventId}
                eventShortName={eventShortName}
                handleSubmitAccount={(value) => handleSubmitAccount(value)}
            />

            <EventDialog
                isOpen={isOpenDialogEvent}
                handleClose={handleCloseDialogEvent}
                eventId={eventId}
                eventShortName={eventShortName}
                dataAccount={dataAccount}
            />

            <AlertDialog
                title={<FormattedMessage id="dialog.confirmDeleteTitle" />}
                handleClose={handleCloseDialogDelete}
                handleOpen={isOpenDialogDelete}
                handleSubmit={handleDeleteEvent}
                contents="削除しますか？"
            />

            <SnackBar
                open={isOpenSnackBar.isOpen}
                onClose={() => setIsOpenSnackBar({ isOpen: false, color: '' })}
                message={messageAction}
                severity={isOpenSnackBar.color}
                autoHideDuration={3000}
            />

            <Loader isLoading={isLoading} />
        </div>
    );
};

ListEvents.defaultProps = {
    listEvents: {},
    dataEvents: {},
    createSuccess: false,
    editSuccess: false,
    deleteSucces: false,
    deleteError: {},
    clearListEvent: () => {},
};

ListEvents.propTypes = {
    fetchListEvents: PropTypes.func.isRequired,
    listEvents: PropTypes.oneOfType([() => null, PropTypes.array]),
    fetchClearGetDetailEvent: PropTypes.func.isRequired,
    createSuccess: PropTypes.bool,
    editSuccess: PropTypes.bool,
    dataEvents: PropTypes.oneOfType([() => null, PropTypes.array]),
    fetchDeleteEvent: PropTypes.func.isRequired,
    deleteSucces: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    clearDetailEvent: PropTypes.func.isRequired,
    deleteError: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearListEvent: PropTypes.func,
};

ActionRow.propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default ListEvents;
